export const validateDob = (dob: string | undefined) => {
  if (!dob) return false;
  console.log(dob);
  const regex = /^\d{4}([\/-])\d{2}\1\d{2}$/;

  if (!regex.test(dob)) {
    return false;
  }

  const [year, month, day] = dob.split(/[\/-]/).map(Number);
  console.log(day, month, year);
  const date = new Date(year, month - 1, day);

  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
};

export const formatDoB = (dob: string): string => {
  const parts = (dob ?? '').trim().split(/[\/-]+/); // grabs all number groups
  if (!parts || parts.length < 3) return dob;

  const [yS, mS, dS] = parts;
  const y = Number(yS);
  const m = Number(mS);
  const d = Number(dS);

  return `${String(y).padStart(4, '0')}/${String(m).padStart(2, '0')}/${String(
    d,
  ).padStart(2, '0')}`;
};
